import React, { Component } from 'react';

import { Singleton } from '../../js/Singleton';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { CellIConAlert, SendMessageIcon } from '../../Images/ManualCallSVG';

class AlertManualMessageWindow extends Component {
	constructor(props) {
		super(props);
		this.language = new Singleton();

		this.state = {
			recievedAlert: true
		};
	}

	getMessageAlert = (complete = false) => {
		let message = this.props.alertCode === 'CUSTOM' ? this.props.message : this.language.getText('GUIManualMessageErrors' + this.props.alertCode);
		if (!complete && message && message.length > 100) {
			message = message.slice(0, 90) + '...';
		}
		return message;
	};

	onClickHandler = () => {
		this.props.closeAlert(false);
	};

	render() {
		const isSending = this.props.alertCode === 'CUSTOM';
		return (
			<div className='alertWindowContainer'>
				<div className='alertWindow'>
					{isSending ? null : <p className='alertNumber'>{this.props.phoneNumber}</p>}
					<div className={`alertInfoContainerManualMessage ${isSending ? 'alertInfoContainerSending' : ''}`}>
						{
							isSending ? 
							<div className='alertWindowSending'><SendMessageIcon width='4.875rem' height='4.625rem' fill='white' /></div>
							:
							<div className='iconAlertManualMessage'><CellIConAlert opacity={1} fill="rgba(255,255,255,1)" width={40} height={40} /></div>
						}
						<OverlayTrigger
							key='tlt-alertManualCallWindow'
							placement='right'
							overlay={
								<Tooltip className='workbar-tooltip show' id='tooltipId-tlt-alertManualCallWindow'>
									{this.getMessageAlert(true)}
								</Tooltip>
							}>
							<div>
								{isSending ? <p className={`alertNumber ${isSending ? 'alertNumberSending' : ''}`}>{this.props.phoneNumber}</p> : null}
								<p className={`alertText ${isSending ? 'alertTextSending' : ''}`}>{this.getMessageAlert()}</p>
							</div>
						</OverlayTrigger>
					</div>
					{
						isSending ? 
						null
						: 
						<div className='closeAlert' onClick={this.onClickHandler}>
							{this.language.getText('GUIManualMessageclose-component')}
						</div>
					}
				</div>
			</div>
		);
	}
}

export default AlertManualMessageWindow;



// WEBPACK FOOTER //
// ./src/components/Alerts/AlertManualMessageWindow.jsx